import React, { forwardRef, useImperativeHandle } from 'react';
import { Modal, Form, Input, DatePicker } from 'antd';
import moment from 'moment';

export default forwardRef((props, ref) => {
  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({ form }));
  const erpCancel = () => {
    props.setCancelErpInfo(undefined);
  };
  const erpOk = () => {
    form.validateFields().then((values) => {
      props.orderPurchaseErpReverse({ order_no: props.order_no, post_date: values.post_date.format('YYYY-MM-DD') });
    });
  };
  return (
    <Modal open={true} title="取消ERP订单" onCancel={erpCancel} onOk={erpOk}>
      <Form form={form} initialValues={{ order_no: props.erp_order_no, post_date: moment(props.post_date) }} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }}>
        <Form.Item label="ERP订单编号" name="order_no" >
          <Input readOnly />
        </Form.Item>
        <Form.Item label="记账日期" name="post_date" rules={[{ required: true, message: '请选择记账日期' },]}>
          <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" disabledDate={current => current && current < moment(props.post_date).add(1, 'day')} />
        </Form.Item>
      </Form>
    </Modal>
  );
});
